/* eslint-disable no-param-reassign */
import Modal from "../common/classes/modal";
import {
  DOWNLOAD_MODAL_CONTENT,
  EXTENDED_IMAGE_HEIGHT_SOFT_UIDS,
} from "../constants/downloadModalContent";

function clearModalContent({ modalImageEl, modalTitleEl, modalLinkEl, modalTextEl } = {}) {
  modalImageEl.alt = "";
  modalImageEl.className = "image-icon";
  modalImageEl.src = "";
  modalLinkEl.href = "#";
  modalTextEl.innerHTML = "";
  modalTitleEl.innerHTML = "";
}

function updateModalContent({
  modalControlEl,
  modalImageEl,
  modalLinkEl,
  modalTextEl,
  modalTitleEl,
  softCategory,
  softIcon,
  softName,
  softUid,
  softUrl,
  isRemoteDownload,
} = {}) {
  modalControlEl.innerHTML = isRemoteDownload ? DOWNLOAD_MODAL_CONTENT.firstStep.remote : DOWNLOAD_MODAL_CONTENT.firstStep.direct;
  modalImageEl.alt = softName;
  modalImageEl.src = softIcon || "";

  if (isRemoteDownload && EXTENDED_IMAGE_HEIGHT_SOFT_UIDS.some(uid => softUid.includes(uid))) {
    modalImageEl.classList.add("extended-image-height");
  }

  modalLinkEl.dataset.articleCategory = softCategory;
  modalLinkEl.dataset.image = softIcon || "";
  modalLinkEl.dataset.name = softName;
  modalLinkEl.dataset.uid = softUid;
  modalLinkEl.href = softUrl;
  modalTextEl.innerHTML = isRemoteDownload ? DOWNLOAD_MODAL_CONTENT.subtitle.remote : DOWNLOAD_MODAL_CONTENT.subtitle.direct;
  modalTitleEl.innerHTML = `<h1>${DOWNLOAD_MODAL_CONTENT.title.replace(/\$softName/g, softName)}</h1>`;
}

function openDownloadModal({ softName, softUrl, softIcon, softUid, softCategory, isRemoteDownload }) {
  const modalControlEl = document.getElementById("control-text");
  const modalImageEl = document.getElementById("download-image");
  const modalLinkEl = document.getElementById("download-link");
  const modalTextEl = document.getElementById("download-text");
  const modalTitleEl = document.getElementById("download-name");

  const modal = new Modal({
    elementId: "download-modal",
    onCloseCallback: () => clearModalContent({
      modalControlEl,
      modalImageEl,
      modalLinkEl,
      modalTextEl,
      modalTitleEl,
    }),
  });

  updateModalContent({
    modalControlEl,
    modalImageEl,
    modalLinkEl,
    modalTextEl,
    modalTitleEl,
    softCategory,
    softIcon,
    softName,
    softUid,
    softUrl,
    isRemoteDownload,
  });

  const modalControls = document.querySelectorAll(".control");
  modalControls.forEach(el => el.classList.remove("active"));

  const targetControl = document.querySelector(`.control[data-control-type="${isRemoteDownload ? "external" : "direct"}"]`);
  if (targetControl) {
    targetControl.classList.add("active");
  }

  modal.open();
}

export default openDownloadModal;
